<template>
  <v-container grid-list-md>
    <v-card class="elevation-0 transparent" height="70px">
      <v-card-title 
        primary-title 
        class="layout justify-center"
      >
        <div class="h_second_line">
          {{ $t('h_about_head_02') }}
        </div>
      </v-card-title>
    </v-card>
    <v-divider></v-divider>
    <v-layout 
      row 
      wrap
    >
      <v-timeline class="justify-center">
        <v-timeline-item
          v-for="item in orderedRoadMap"
          :key="item.number"
          :color="item.color"
          :icon="item.icon"
          fill-dot
        >
          <template v-slot:opposite>
            <span class="timetext">From {{item.date_from}} to {{item.date_to}}</span>
          </template>
          <v-hover
            v-slot:default="{ hover }"
          >
            <v-card
              :elevation="hover ? 12 : 2"
              class="mx-auto"
              :color="item.color"
            >
              <v-container fluid>
                <v-layout row>
                  <v-flex 
                    xs6
                    md10
                  >
                    <v-card-text class="white--text">
                      <div class="headline mb-2">{{item.position}}</div>
                      {{item.org}}
                      <v-divider class="white"></v-divider>
                      <div>{{item.description}}</div>
                    </v-card-text>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-hover>
        </v-timeline-item>
      </v-timeline>
    </v-layout>
  </v-container>
</template>

<script>
  import _ from 'lodash'
  export default {
    computed:{
      roadMap(){
        return this.$store.getters.getRM
      },
      orderedRoadMap: function () {
        return _.orderBy(this.roadMap, "number").reverse()
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>